import { ReactElement } from "react";
import { className, getColorVariantClassname } from "../../../shared/helpers";
import styles from "./IndicatorBadge.module.scss";

interface IndicatorBadgeProps
{
    statusId: number;
    statusName: string;
}

const IndicatorBadge = (props: IndicatorBadgeProps): ReactElement => (
    <div title={props.statusName} {...className(styles.badge, getColorVariantClassname(props.statusId))}>
        <span>{props.statusName}</span>
    </div>
);

export default IndicatorBadge;